import { useCallback } from 'react';
import { useServiceTypes } from './useServiceTypes';
import { tradeColorToFamily } from '@/components/dispatch/trade-family';
import type { TintFamily } from '@/components/molecules/status-tokens';

/**
 * NOT-329 — resolve a serviceType to its Trade tint family for the `jobtype`
 * color mode (curated Trade palette, not a hash). Unknown → undefined → the
 * surface degrades to its status colouring.
 *
 * Shared so the map pins, the dispatch timeline and the calendar tiles all
 * resolve `jobtype` identically; one booking reading as two colours on one
 * screen is exactly the bug this removes. The query is cached, so calling this
 * from several components on the same screen costs nothing extra.
 */
export function useJobTypeFamilyResolver(): (serviceTypeId: string) => TintFamily | undefined {
  const { data: serviceTypes } = useServiceTypes();

  return useCallback(
    (serviceTypeId: string) =>
      tradeColorToFamily((serviceTypes ?? []).find((s) => s.id === serviceTypeId)?.trade?.color),
    [serviceTypes],
  );
}
